import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-next",
  "use": "icon-next-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-next\">\n   \n   \n        <polyline id=\"icon-next_Stroke-1-Copy-9\" stroke-width=\"2\" points=\"24 5.76 18.0002078 11.5899135 11.9998614 17.4195499 6.00006928 11.5899135 0 5.76\" />\n   \n</symbol>"
});
var result = sprite.add(symbol);
export default symbol